module.exports = __webpack_public_path__ + "img/go-unconfined-min.fd833325.jpg";